import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchPurchasingPerformance, setDefaultOfForm, fetchPurchasingPerformanceByProduct, setDefaultSearchType, setAllProducts, resetAllProducts, fetchPurchaseOrderList, changeFormValue } from '../../actions/purchaseOrders_actions';
import { fetchVendors } from '../../actions/vendors_actions';
import PurchasingPerformance from '../../components/Purchase/purchasingPerformance';
import { fetchProductInfo, fetchSimplifiedProducts } from '../../actions/products_actions';
import { fetchPurchasePerformanceByFilter } from '../../actions/purchasingPerformanceList_actions';

let purchasingPerformance = reduxForm({
  form: 'purchasingPerformance',
})(PurchasingPerformance);

const selector = formValueSelector('purchasingPerformance');

function mapStateToProps(state) {
    const Days = selector(state, 'Days');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');
    const POStatus = selector(state, 'POStatus');
    const Vendor_id = selector(state, 'Vendor_id');
    const searchType = selector(state, 'searchType');
    const allProducts = selector(state, 'AllProducts');
    const Product_id = selector(state, 'Product_id');

    return {
        Days,
        FromDate,
        ToDate,
        POStatus,
        Vendor_id,
        searchType,
        allProducts,
        Product_id,
        vendors: state.vendors.all,
        purchasingPerformanceIsLoading: state.purchaseOrders.purchasingPerformanceIsLoading,
        purchasingPerformance: state.purchaseOrders.purchasingPerformance,
        purchasingPerformanceError: state.purchaseOrders.purchasingPerformanceError,
        purchaseOrderPerformanceByProductIsLoading: state.purchaseOrders.purchaseOrderPerformanceByProductIsLoading,
        purchaseOrderPerformanceByProduct: state.purchaseOrders.purchaseOrderPerformanceByProduct,
        purchaseOrderPerformanceByProductError: state.purchaseOrders.purchaseOrderPerformanceByProductError,

        simplifiedProducts: state.products.simplifiedProducts,
        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
        simplifiedProductsError: state.products.simplifiedProductsError,

        productInfo: state.products.productInfo,
        productInfoIsLoading: state.products.productInfoIsLoading,
        productInfoError: state.products.productInfoError,

        purchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
        purchaseOrderDetailIsLoading: state.purchaseOrders.detailIsLoading,
        purchaseOrderDetailError: state.purchaseOrders.detailError,

        purchaseOrderList: state.purchaseOrders.purchaseOrderList,
        purchaseOrderListIsLoading: state.purchaseOrders.purchaseOrderListIsLoading,
        purchaseOrderListError: state.purchaseOrders.purchaseOrderListError,

        selectedWarehouse: state.header.selectedWarehouse,
        selectedCompany: state.header.selectedCompany,
    };
}

export default connect(mapStateToProps, {
  fetchPurchasePerformanceByFilter, fetchPurchasingPerformance, setDefaultOfForm,
  fetchVendors, fetchPurchasingPerformanceByProduct, setDefaultSearchType,setAllProducts, resetAllProducts,
  fetchPurchaseOrderList, fetchProductInfo, fetchSimplifiedProducts, changeFormValue })(purchasingPerformance);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchasingPerformance.jsx